"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownItem = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../styles");
function DropdownItem(props) {
    var type = props.type, disabled = props.disabled, children = props.children, onClick = props.onClick, Component = props.component, rest = __rest(props, ["type", "disabled", "children", "onClick", "component"]);
    var _a = styles_1.useStyles(styles), classes = _a.classes, css = _a.css;
    var handleKeyDown = function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
            var elem = event.target;
            elem.click();
        }
    };
    var handleClick = function (e) {
        if (disabled) {
            e.stopPropagation(); // avoid closing dropdown menu when disabled item is clicked
        }
        else {
            onClick && onClick(e);
        }
    };
    var classNames = css(classes.item, type === 'danger' && classes.danger, disabled && classes.disabled);
    return (react_1.default.createElement(Component, __assign({ className: classNames, onClick: handleClick, onKeyDown: handleKeyDown, role: 'menuitem', "aria-disabled": disabled ? true : undefined }, rest), children));
}
exports.DropdownItem = DropdownItem;
DropdownItem.defaultProps = {
    component: 'li',
    type: 'normal',
    disabled: false,
};
var styles = function (theme) { return ({
    item: __assign(__assign({}, theme.typography.variant('main')), { margin: 0, textDecoration: 'none', cursor: 'pointer', padding: 'calc(0.5rem - 2px) 1rem', lineHeight: '1.25rem', fontWeight: 'bold', outline: 'none', fontSize: theme.typography.sizes.button, transition: 'all .2s ease', display: 'block', '&:hover': {
            background: theme.pallete.surface.background,
        }, '&:focus': {
            boxShadow: styles_1.focusBoxShadow(theme, 'primary', 'inset'),
            borderRadius: 4,
        } }),
    disabled: {
        color: theme.pallete.text.disabled,
        '&:hover': {
            cursor: 'not-allowed',
            background: 'transparent',
            color: theme.pallete.text.disabled,
        },
    },
    danger: {
        color: theme.pallete.status.danger.main,
        '&:hover': {
            color: theme.pallete.surface.main,
            background: theme.pallete.status.danger.main,
        },
        '&:focus': {
            boxShadow: styles_1.focusBoxShadow(theme, 'danger', 'inset'),
            borderRadius: 4,
        },
    },
}); };
//# sourceMappingURL=DropdownItem.js.map